import {
  TrainingStatusAPIData,
  TrainingStatusVueData,
  StatusBarColor,
  LoginFormData,
  MonthTrainingStatusParUser,
  DemoVideo,
  GroupRes,
  YearInfo,
  ChatAPIData,
  ChatByIDAPIData,
  ChartSortTrainings,
  TrainingCategoryAPIData,
  GroupFavoriteCategoryAPIData,
  ChartOutputType,
  ContractReq,
  ContractChartRes,
} from './types';

import axios, {AxiosResponse} from 'axios';
import store from '../store/index';

// const baseURL = 'https://vrapp-3dakogmbua-an.a.run.app/audit/'
// const baseURL = 'http://localhost:8080/audit/'
let baseURL = process.env.VUE_APP_URL;
const basev2URL = process.env.VUE_APP_V2_URL;
let protoURL = process.env.VUE_APP_PROTO_URL;

if (process.env) {
  if (process.env.NODE_ENV == 'test') {
    baseURL = 'http://localhost:8080/audit/';
  }
  if (process.env.NODE_ENV == 'test') {
    protoURL = 'http://localhost:8080';
  }
}

console.log(baseURL);
console.log(basev2URL);
console.log(protoURL);

// baseURL = 'https://vrapp-l2oi27p23a-an.a.run.app/audit/';

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const user = store.state.user;
    if (error.response.status === 401 && user) {
      try {
        await store.dispatch('logout');
      } catch (err) {
        console.log(`401 error logout:${err}`);
      }
    }
    return Promise.reject(error);
  }
);

const apiClientV2 = axios.create({
  baseURL: basev2URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClientV2.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

apiClientV2.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const user = store.state.user;
    if (error.response.status === 401 && user) {
      try {
        await store.dispatch('logout');
      } catch (err) {
        console.log(`401 error logout:${err}`);
      }
    }
    return Promise.reject(error);
  }
);

const protoClient = axios.create({
  baseURL: protoURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

protoClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

function getColor(val: number): StatusBarColor {
  if (val > 80) {
    return 'green';
  } else if (val > 50) {
    return 'yellow';
  } else {
    return 'red';
  }
}

export default {
  getReference(url: string): Promise<AxiosResponse<Blob>> {
    return axios.get(url, {responseType: 'blob'});
  },

  getGroup(token: string): Promise<AxiosResponse<Array<GroupRes>>> {
    return protoClient.get('/groups/', {
      headers: {Authorization: `Bearer ${token}`},
      params: {target: 'all'},
    });
  },

  getYearInfo(token: string, year: number): Promise<AxiosResponse<YearInfo>> {
    return protoClient.get(`/years/range/${year}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  postContractChart(
    token: string,
    data: ContractReq
  ): Promise<AxiosResponse<ContractChartRes>> {
    return protoClient.post('/contracts/chart', data, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  postContractChartDownload(
    token: string,
    data: ContractReq
  ): Promise<AxiosResponse<BlobPart>> {
    return protoClient.post('/contracts/file', data, {
      headers: {Authorization: `Bearer ${token}`},
      responseType: 'blob',
    });
  },

  postLogin(data: LoginFormData): Promise<AxiosResponse<string>> {
    return apiClient.post('/login', data);
  },

  postDeadline(
    token: string,
    trainingID: string,
    deadline: string
  ): Promise<AxiosResponse<string>> {
    return apiClient.post(
      `/trainings/${trainingID}/deadline`,
      {deadline: deadline},
      {
        headers: {Authorization: `Bearer ${token}`},
      }
    );
  },

  getTrainings(
    token: string,
    year: string,
    main = true,
    group = 'truck'
  ): Promise<AxiosResponse<Array<TrainingStatusAPIData>>> {
    const url = main
      ? `/trainings/group/${group}/all?year=${year}`
      : `/trainings/group/${group}/hiari/all?year=${year}`;
    return apiClientV2.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  getFavoriteTrainingCategory(
    token: string
  ): Promise<AxiosResponse<TrainingCategoryAPIData>> {
    const url = `/categories/trainings/favorite`;
    return protoClient.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  updateFavoriteTrainingIDs(
    token: string,
    param: {
      favoriteIDs: string[];
    }
  ): Promise<AxiosResponse<void>> {
    const url = `/categories/trainings/favorite`;
    return protoClient.put('/categories/trainings/favorite', param, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  listGroupFavorite(
    token: string
  ): Promise<AxiosResponse<GroupFavoriteCategoryAPIData>> {
    return protoClient.get(`/groups/categories/trainings/favorite`, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  copyFavorite(
    token: string,
    param: {
      favoriteIDs: string[];
      updateBranchOfficeIDs: Array<string>;
    }
  ): Promise<AxiosResponse<void>> {
    return protoClient.post(
      `/groups/categories/trainings/favorite/copy`,
      param,
      {
        headers: {Authorization: `Bearer ${token}`},
      }
    );
  },

  getChartInfo(
    token: string,
    year: string,
    main = true,
    group = 'truck',
    sortBy: ChartSortTrainings = ChartSortTrainings.Default
  ): Promise<AxiosResponse<ChatAPIData>> {
    const url = main
      ? `/chart/${group}/all?year=${year}&sort=${sortBy}`
      : `/chart/${group}/hiari/all?year=${year}&sort=${sortBy}`;
    return apiClientV2.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  getChartByIDInfo(
    token: string,
    year: string,
    main = true,
    group = 'truck',
    trainingID: string
  ): Promise<AxiosResponse<ChatByIDAPIData>> {
    const url = main
      ? `/chart/${group}/progress/${trainingID}?year=${year}&sort=${ChartSortTrainings.Default}`
      : `/chart/${group}/hiari/progress/${trainingID}?year=${year}&sort=${ChartSortTrainings.Default}`;
    return apiClientV2.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  downloadChartInfo(
    token: string,
    year: string,
    main = true,
    group = 'truck',
    category: string,
    sortBy: ChartSortTrainings = ChartSortTrainings.Default,
    outputType: ChartOutputType = ChartOutputType.Default
  ): Promise<AxiosResponse<BlobPart>> {
    const url = main
      ? `/chart/${group}/all/download?year=${year}&sort=${sortBy}`
      : `/chart/${group}/hiari/all/download?year=${year}&sort=${sortBy}&filter=${category}&type=${outputType}`;
    return apiClientV2.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });
  },

  downloadChartByIDInfo(
    token: string,
    year: string,
    main = true,
    group = 'truck',
    trainingID: string
  ): Promise<AxiosResponse<BlobPart>> {
    const url = main
      ? `/chart/${group}/progress/download/${trainingID}?year=${year}&sort=${ChartSortTrainings.Default}`
      : `/chart/${group}/hiari/progress/download/${trainingID}?year=${year}&sort=${ChartSortTrainings.Default}`;
    return apiClientV2.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });
  },

  getMonthStatus(
    month: string,
    token: string,
    year: string
  ): Promise<AxiosResponse<MonthTrainingStatusParUser>> {
    return apiClient.get(`/trainings/${month}?year=${year}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  putUsersStatus(
    token: string,
    trainingID: string,
    users: Array<string>
  ): Promise<AxiosResponse<void>> {
    return apiClient.put(
      '/users/',
      {
        status: 'done',
        users: users,
        trainingID: trainingID,
      },
      {
        headers: {Authorization: `Bearer ${token}`},
      }
    );
  },

  getDemoVideo(token: string): Promise<AxiosResponse<DemoVideo>> {
    return apiClient.get('/demo-video/', {
      headers: {Authorization: `Bearer ${token}`},
    });
  },

  convertTrainings(
    trainings: Array<TrainingStatusAPIData>
  ): Array<TrainingStatusVueData> {
    const tabledata: Array<TrainingStatusVueData> = [];

    trainings.forEach(t => {
      tabledata.push({
        val: (t.done / t.total) * 100,
        done: t.done,
        total: t.total,
        summary: t.detail,
        targetMonth: t.month,
        color: getColor((t.done / t.total) * 100),
        url: t.url,
      });
    });

    const month = new Date().getMonth() + 1;
    const cmp = (a: TrainingStatusVueData, b: TrainingStatusVueData) => {
      const monthA = Number(a.targetMonth);
      const monthB = Number(b.targetMonth);
      const ca = (monthA + month) % 12;
      const cb = (monthB + month) % 12;
      if (ca > cb) {
        return 1;
      } else if (cb > ca) {
        return -1;
      }
      return 0;
    };

    try {
      tabledata.sort(cmp);
    } catch (err) {
      console.log(err);
    }

    return tabledata;
  },

  ProtoURL: (): string => protoURL,

  getSafetyEducationIndexFormat: (src: number): string => {
    const outputsample = [
      '',
      '①',
      '②',
      '③',
      '④',
      '⑤',
      '⑥',
      '⑦',
      '⑧',
      '⑨',
      '⑩',
      '⑪',
      '⑫',
    ];
    if (0 < src && src < 13) {
      return outputsample[src];
    } else {
      return ' ';
    }
  },

  // TODO (ohtsuchi) 2025年以降 コードを削除
  existsConfSortBy(token: string): Promise<AxiosResponse<ConfSortByData>> {
    const url = `/conf/sortBy/`;
    return apiClientV2.get(url, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },
};

// TODO (ohtsuchi) 2025年以降 コードを削除
type ConfSortByData = {
  exists: boolean;
};
